<template>
  <nav class="navbar fixed-top navbar-dark bg-dark">
    <a class="navbar-brand" href="/">Base2 Portal</a>

    <ul class="nav nav-pages mr-auto">

      <li class="nav-item active">
        <router-link title="Work Metrics" :to="{ name: 'Cards', params: { id: this.activeId } }">
          <img v-if="$route.name === 'Cards'" class="links" src="../assets/baseline-cards-24px-active.svg">
          <img v-else class="links" src="../assets/baseline-cards-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Boards" :to="{ name: 'Work', params: { id: this.activeId }}">
          <img v-if="$route.name === 'Work'" class="links" src="../assets/baseline-work-24px-active.svg">
          <img v-else class="links" src="../assets/baseline-work-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Slack" :to="{ name: 'Base2Bot', params: { id: this.activeId } }">
          <img v-if="$route.name === 'Base2Bot'" class="links" src="../assets/baseline-chat-24px-active.svg">
          <img v-else class="links" src="../assets/baseline-chat-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Zendesk Summary" :to="{ name: 'ZendeskSummary', params: { id: this.activeId } }">
          <img v-if="$route.name === 'ZendeskSummary'" class="links" src="../assets/zendesk-24px-active.svg">
          <img v-else class="links" src="../assets/zendesk-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Alerts" :to="{ name: 'Alerts', params: { id: this.activeId } }">
          <img v-if="$route.name === 'Alerts'" class="links" src="../assets/baseline-alerts-24px-active.svg">
          <img v-else class="links" src="../assets/baseline-alerts-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Incoming Calls" :to="{ name: 'IncomingCalls', params: { id: this.activeId } }">
          <img v-if="$route.name === 'IncomingCalls'" class="links" src="../assets/baseline-calls-24px-active.svg">
          <img v-else class="links" src="../assets/baseline-calls-24px.svg">
        </router-link>
      </li>

      <li class="nav-item dropdown">
        <div href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Shelvery">
          <img v-if="$route.name.match( /ShelveryService|Shelvery/g )" class="links" src="../assets/baseline-restore-24px-active.svg">
          <img v-else class="links" src="../assets/baseline-restore-24px.svg">
        </div>
        <div class="dropdown-menu" aria-labelledby="navbarDropdown">
          <router-link class="dropdown-item"
              :to="{ name: 'Shelvery', params: { id: this.activeId } }">
            summary
          </router-link>

          <div class="dropdown-divider"></div>

          <router-link class="dropdown-item"
              :to="{ name: 'ShelveryService', params: { id: this.activeId, service: 'ebs' } }">
            ebs
          </router-link>

          <router-link class="dropdown-item"
              :to="{ name: 'ShelveryService', params: { id: this.activeId, service: 'rds' } }">
            rds
          </router-link>

          <router-link class="dropdown-item"
              :to="{ name: 'ShelveryService', params: { id: this.activeId, service: 'ami' } }">
            ami
          </router-link>

          <router-link class="dropdown-item"
              :to="{ name: 'ShelveryService', params: { id: this.activeId, service: 'redshift' } }">
            redshift
          </router-link>
        </div>
      </li>

      <!-- <li class="nav-item active">
        <router-link title="Deployments" :to="{ name: 'Deployments', params: { id: this.activeId } }">
          <img v-if="$route.name === 'Deployments'" class="links" src="../assets/baseline-deployment-24px-active.svg">
          <img v-else class="links" src="../assets/baseline-deployment-24px.svg">
        </router-link>
      </li> -->

      <li class="nav-item active">
        <router-link title="Tools" :to="{ name: 'Tools', params: { id: this.activeId } }">
          <img v-if="$route.name === 'Tools'" class="links" src="../assets/baseline-tools-24px-active.svg">
          <img v-else class="links" src="../assets/baseline-tools-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Backups" :to="{ name: 'Backups', params: { id: this.activeId } }">
          <img v-if="$route.name.match( /BackupService|Backups/g )" class="links" src="../assets/backups-24px-active.svg">
          <img v-else class="links" src="../assets/backups-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Monitoring" :to="{ name: 'Monitoring', params: { id: this.activeId } }">
          <img v-if="$route.name === 'Monitoring'" class="links" src="../assets/monitor_heart_active_24dp.svg">
          <img v-else class="links" src="../assets/monitor_heart_white_24dp.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="OpsTools" :to="{ name: 'OpsTools', params: { id: this.activeId } }">
          <img v-if="$route.name === 'OpsTools'" class="links" src="../assets/priority-24px-active.svg">
          <img v-else class="links" src="../assets/priority-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Resources" :to="{ name: 'Resources', params: { id: this.activeId, resource: 'lambda' } }">
          <img v-if="$route.name === 'Resources'" class="links" src="../assets/resources-24px-active.svg">
          <img v-else class="links" src="../assets/resources-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Assets" :to="{ name: 'Assets', params: { id: this.activeId } }">
          <img v-if="$route.name === 'Assets'" class="links" src="../assets/assets-24px-active.svg">
          <img v-else class="links" src="../assets/assets-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Ciinabox Deployments" :to="{ name: 'CiinaboxDeployments', params: { id: this.activeId } }">
          <img v-if="$route.name === 'CiinaboxDeployments'" class="links" src="../assets/deployments-active-24px.svg">
          <img v-else class="links" src="../assets/deployments-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="Costs" :to="{ name: 'Costs', params: { id: this.activeId} }">
          <img v-if="$route.name === 'Costs'" class="links" src="../assets/costs-24px-active.svg">
          <img v-else class="links" src="../assets/costs-24px.svg">
        </router-link>
      </li>

      <li class="nav-item active">
        <router-link title="InsightsTester" :to="{ name: 'InsightsTester', params: { id: this.activeId } }">
          <img v-if="$route.name === 'InsightsTester'" class="links" src="../assets/wand-stars-active.svg">
          <img v-else class="links" src="../assets/wand-stars.svg">
        </router-link>
      </li>
      <li class="nav-item active">
        <router-link title="AIPage" :to="{ name: 'AIPage', params: { id: this.activeId } }">
          <img v-if="$route.name === 'AIPage'" class="links" src="../assets/costs-24px-active.svg">
          <img v-else class="links" src="../assets/costs-24px.svg">
        </router-link>
      </li>

    </ul>

    <div class="nav-item dropdown">
      <div href="#" id="mgtDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" title="Manage Contracts">
        <img v-if="$route.name.match( /Management|NewContract/g )" class="links" src="../assets/management-24px-active.svg">
        <img v-else class="links" src="../assets/management-24px.svg">
      </div>
      <div class="dropdown-menu dropdown-menu-right dropdown-menu-lg-left" aria-labelledby="mgtDropdown">
        <h6 class="dropdown-header">Groups</h6>
        <router-link class="dropdown-item" title="Modify Group"
          :to="{ name: 'GroupNew' }">
          New Group
        </router-link>
        <router-link v-if="activeType == 'group'" class="dropdown-item" title="Modify Group"
          :to="{ name: 'GroupModify', params: { id: this.activeId } }">
          Modify Group
        </router-link>
        <router-link v-if="activeType == 'group'" class="dropdown-item" title="Delete Group"
          :to="{ name: 'GroupDelete', params: { id: this.activeId } }">
          Delete Group
        </router-link>
        <h6 class="dropdown-header">Contract</h6>
        <router-link class="dropdown-item" title="New Contract"
          :to="{ name: 'ContractNew' }">
          New Contract
        </router-link>
        <router-link v-if="activeType == 'contract'" class="dropdown-item" title="Modify Contract"
          :to="{ name: 'ContractModify', params: { id: this.activeId } }">
          Modify Contract
        </router-link>
        <router-link v-if="activeType == 'contract'" class="dropdown-item" title="Delete Contract"
          :to="{ name: 'ContractDelete', params: { id: this.activeId } }">
          Delete Contract
        </router-link>
      </div>
    </div>

    <div title="Settings"><img class="settings" width="24px" src="../assets/settings-white-18dp.svg" data-toggle="modal" data-target="#modal"></div>

    <div class="modal fade" id="modal" tabindex="-1" role="dialog" aria-labelledby="Settings" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Settings</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="toggle-group">
              <!-- Global Settings -->
              <div class="namespace">global settings</div>
              <div class="toggle">
                <div class="toggle-text">dots</div>
                <button type="button" v-on:click="toggleSetting('global', 'dots')" class="btn btn-toggle" v-bind:class="{ active: settings.global.dots }" aria-pressed="true" autocomplete="off">
                  <div class="handle"></div>
                </button>
              </div>
              <div class="toggle">
                <div class="toggle-text">week numbers</div>
                <button type="button" v-on:click="toggleSetting('global', 'weekNumbers')" class="btn btn-toggle" v-bind:class="{ active: settings.global.weekNumbers }" aria-pressed="true" autocomplete="off">
                  <div class="handle"></div>
                </button>
              </div>
              <!-- Work Settings -->
              <div v-if="$route.name === 'Work' || $route.name === 'Cards'" class="namespace">local settings</div>
              <div v-if="$route.name === 'Work'" class="toggle">
                <div class="toggle-text">show platform icons</div>
                <button type="button" v-on:click="toggleSetting('work', 'icons')" class="btn btn-toggle" v-bind:class="{ active: settings.work.icons }" aria-pressed="true" autocomplete="off">
                  <div class="handle"></div>
                </button>
              </div>
              <div v-if="$route.name === 'Work'" class="toggle">
                <div class="toggle-text">show zendesk tickets</div>
                <button type="button" v-on:click="toggleSetting('work', 'zendesk')" class="btn btn-toggle" v-bind:class="{ active: settings.work.zendesk }" aria-pressed="true" autocomplete="off">
                  <div class="handle"></div>
                </button>
              </div>
              <div v-if="$route.name === 'Work'" class="toggle">
                <div class="toggle-text">show trello cards</div>
                <button type="button" v-on:click="toggleSetting('work', 'trello')" class="btn btn-toggle" v-bind:class="{ active: settings.work.trello }" aria-pressed="true" autocomplete="off">
                  <div class="handle"></div>
                </button>
              </div>
              <div v-if="$route.name === 'Work'" class="toggle">
                <div class="toggle-text">show jira cards</div>
                <button type="button" v-on:click="toggleSetting('work', 'jira')" class="btn btn-toggle btn-jira" v-bind:class="{ active: settings.work.jira }" aria-pressed="true" autocomplete="off">
                  <div class="handle"></div>
                </button>
              </div>
              <div v-if="$route.name === 'Work'" class="toggle">
                <div class="toggle-text">show planned cards</div>
                <button type="button" v-on:click="toggleSetting('work', 'queue')" class="btn btn-toggle btn-queue" v-bind:class="{ active: settings.work.queue }" aria-pressed="true" autocomplete="off">
                  <div class="handle"></div>
                </button>
              </div>
              <div v-if="$route.name === 'Cards'" class="toggle">
                <div class="toggle-text">show labels</div>
                <button type="button" v-on:click="toggleSetting('cards', 'labels')" class="btn btn-toggle" v-bind:class="{ active: settings.cards.labels }" aria-pressed="true" autocomplete="off">
                  <div class="handle"></div>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div title="Logout">
      <img type="button" v-on:click="logout" class="settings" width="24px" src="../assets/logout-24dp.svg">
    </div>

    <ul class="nav nav-pills">
      <li class="nav-item dropdown">
        <button type="button" class="btn dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{activeId}}
        </button>
        <div class="dropdown-menu dropdown-menu-right scrollable-menu">
          <form class="form-group">
            <input type="search" class="form-control search" id="search" placeholder="filter" autofocus="autofocus" v-model="search">
          </form>
          <h6 class="dropdown-header">Groups</h6>
          <div v-for="group in filteredGroupList" :key="group">
            <a class="dropdown-item" v-on:click="updateActive(group, 'group')">{{ group }}</a>
          </div>
          <h6 class="dropdown-header">Contracts</h6>
          <div v-for="contract in filteredContractList" :key="contract">
            <a class="dropdown-item" v-on:click="updateActive(contract, 'contract')">{{ contract }}</a>
          </div>
        </div>
      </li>
    </ul>

  </nav>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'NavBar',
  props: [
    'id'
  ],
  data () {
    return {
      shelveryServices: [],
      search: ''
    }
  },
  computed: {
    ...mapGetters([
      'activeId',
      'activeType',
      'contracts',
      'groups',
      'settings',
      'refreshToken'
    ]),
    filteredGroupList () {
      return this.groups.filter(group => {
        return group.toLowerCase().includes(this.search.toLowerCase())
      })
    },
    filteredContractList () {
      return this.contracts.filter(contract => {
        return contract.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  watch: {
    activeId: function () {
      this.search = ''
      if (this.activeId) {
        this.$router.push({ name: this.$router.$route, params: { id: this.activeId } }).catch(() => {})
      }
    }
  },
  methods: {
    updateActive: function (activeId) {
      this.$store.dispatch('SET_ACTIVE', activeId)
    },
    toggleSetting: function (namespace, key) {
      this.$store.dispatch('UPDATE_SETTINGS', {
        namespace: namespace,
        key: key,
        value: !this.settings[namespace][key]
      })
    },
    logout: async function () {
      await this.$store.dispatch('REVOKE_TOKEN', this.refreshToken)
      this.$store.dispatch('CLEAR_TOKENS')
      window.location = process.env.AUTH_ENDPOINT + '/logout?' +
        'client_id=' + process.env.COGNITO_APP_CLIENT_ID +
        '&logout_uri=' + process.env.PORTAL_ENDPOINT
    }
  }
}
</script>

<style scoped>
.nav-item  {
  cursor: pointer;
}

.dropdown-item {
  cursor: pointer;
}

.dropdown-menu > a:hover {
    background-image: none;
    background-color: #70A1F0;
}

.scrollable-menu {
  height: auto;
  max-height: 80vh;
  overflow-x: scroll;
}

.links {
  transition: opacity 200ms;
  margin-left: 10px;
  margin-right: 10px;
  width: 20px;
  height: 20px;
}

.links:hover {
  opacity: 0.8;
}

.nav-pages {
  align: left
}

.fixed-top {
  z-index: 2000;
}

/* Settings */

.settings {
  transition: opacity 200ms;
  margin-right: 15px;
  cursor: pointer;
}
.settings:hover {
  opacity: 0.8;
}
.modal-title {
  margin-left: 10px;
}
.namespace {
  line-height: 1.5rem;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  color: #6b7381;
  opacity: 0.3;
  margin-left: 68px;
  padding-top: 20px;
  padding-bottom: 20px;
}
.toggle-group{
  /* padding-top: 15px; */
  padding-bottom: 10px;
}
.toggle {
  position: relative;
  right: -290px;
  padding-top: 10px;
  padding-bottom: 10px;
}
.btn-toggle {
  top: 50%;
  transform: translateY(-50%);
}
.btn-toggle {
  margin: 0 4rem;
  padding: 0;
  position: relative;
  border: none;
  height: 1.5rem;
  width: 3rem;
  border-radius: 1.5rem;
  color: #aaaaaa;
  background: #aaaaaa;
}
.btn-toggle:focus,
.btn-toggle.focus,
.btn-toggle:focus.active,
.btn-toggle.focus.active {
  outline: none;
  box-shadow: none;
}
.toggle-text {
  line-height: 1.5rem;
  font-weight: 600;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 2px;
  position: absolute;
  bottom: 22px;
  left: -222px;;
  color: #6b7381;
}
.btn-toggle > .handle {
  position: absolute;
  top: 0.1875rem;
  left: 0.1875rem;
  width: 1.125rem;
  height: 1.125rem;
  border-radius: 1.125rem;
  background: #fff;
  transition: left 0.25s;
}
.btn-toggle.active {
  transition: background-color 0.25s;
}
.btn-toggle.active > .handle {
  left: 1.6875rem;
  transition: left 0.25s;
}
.btn-toggle.active:before {
  opacity: 1;
}
.btn-toggle.active:after {
  opacity: 0.1;
}
.btn-toggle.btn-sm:before,
.btn-toggle.btn-sm:after {
  line-height: -0.5rem;
  color: #fff;
  letter-spacing: 0.75px;
  left: 0.4125rem;
  width: 2.325rem;
}
.btn-toggle.btn-sm:before {
  text-align: right;
}
.btn-toggle.btn-sm:after {
  text-align: left;
  opacity: 0;
}
.btn-toggle.btn-sm.active:before {
  opacity: 0;
}
.btn-toggle.btn-sm.active:after {
  opacity: 1;
}
.btn-toggle.btn-xs:before,
.btn-toggle.btn-xs:after {
  display: none;
}
.btn-toggle:before,
.btn-toggle:after {
  color: #6b7381;
}
.btn-toggle.active {
  background-color: #77a6f7;
}
.search {
  border: 0;
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid #e5e5e5;
  margin-left: 10px;
  width: 85%;
}
.search:focus,
.search.focus,
.search:focus.active,
.search.focus.active {
  box-shadow: none;
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue